<div class="icon-wrapper">
  @if (show && form) {
    <button mat-icon-button (click)="showError()" tabindex="-1">
      <mat-icon class="warning" [ngbTooltip]="error" tooltipClass="myTooltip" placement="bottom auto" container="body" triggers="hover">error</mat-icon>
    </button>
  }
  @if (show && !form) {
    <button mat-icon-button tabindex="-1">
      <mat-icon class="warning" >error</mat-icon>
    </button>
  }
</div>
